export default {
  checkIn: {
    aboutVisit: {
      am: 'vorm',
      at: 'um',
      choose: 'Wählen',
      hour: 'Stunde',
      meridian: 'vorm/nachm',
      min: 'Min',
      pleaseEnterAValidTimeAndDate: 'Bitte geben Sie eine gültige Zeit und ein gültiges Datum ein',
      pm: 'nachm',
      timeCantBeFuture: 'Datum/Uhrzeit darf nicht in der Zukunft liegen',
      today: 'Heute',
      yesterday: 'Gestern'
    },
    checkIn: {
      info: 'Hier steht einige Information...',
      browserOutdated: 'Ihr Browser ist veraltet. Bitte aktualisieren Sie auf einen {0}modernen Webbrowser{1}.'
    },
    digitalReceipt: {
      currency: '€',
      description: 'Beschreibung',
      discount: 'Rabatt',
      emailReceipt: 'E-Mail-Quittung',
      mealReceipt: 'Essensquittung',
      price: 'Preis',
      save: 'Speichern',
      server: 'KellnerIn',
      serviceCharge: 'Servicegebühr',
      tableNumber: 'Tischnummer',
      total: 'Gesamt',
      yourEmail: 'Ihre E-Mail'
    },
    errors: {
      noSlug: 'Kein Umfragetag übergeben',
      badSlug: 'Ungültiger Umfragetag verwendet'
    },
    guestTableNumberEntry: {
      mustBeANumber: 'Tischnummer muss eine Zahl sein',
      pleaseEnterTableNumber: 'Bitte geben Sie Ihre Tischnummer ein, damit wir Ihre Bestellung finden können',
      tableNumber: 'Tischnummer',
      yourTableNumber: 'Ihre Tischnummer'
    },
    locationCheckIn: {
      checkIn: 'Einchecken',
      freeDesertOnYourNextVisit: 'Kostenloses Dessert bei Ihrem nächsten Besuch',
      pleaseTellUsAboutYourExperience: 'Bitte teilen Sie uns Ihre Erfahrung mit - es dauert weniger als eine Minute!'
    },
    teamMemberReceiptPinEntry: {
      downloadingTransactionData: 'Transaktionsdaten werden heruntergeladen',
      enterPinNumber: 'PIN-Nummer eingeben',
      pinNumber: 'PIN-Nummer'
    },
    teamMemberTableNumberEntry: {
      downloadingTransactionData: 'Transaktionsdaten werden heruntergeladen',
      mustBeANumber: 'Tischnummer muss eine Zahl sein',
      pleaseEnterTableNumber: 'Bitte geben Sie die Tischnummer ein, um Transaktionsdaten herunterzuladen',
      tableNumber: 'Tischnummer',
      noNumber: 'Haben Sie keine Tischnummer?'
    }
  }
};